import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';

import MuteBtn from '../../src/media/MuteBtn.jsx';

let domDeleteEl = document.querySelectorAll('.MuteBtn');
let media;
if (preloaded.video) media = preloaded.video;
if (preloaded.picture) media = preloaded.picture;

if (domDeleteEl) {
  domDeleteEl.forEach( el => {
    ReactDOM.render(<MuteBtn media={media} el={el} />, el);
  });
}